import {
  Component,
  OnInit,
  Input,
  ViewChild,
  QueryList,
  ViewChildren,
  ElementRef,
  AfterViewInit
} from '@angular/core';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

import {
  ClientEventService,
  ServerEventService,
  ApiService,
  MessageService
} from '@radsource/ng-common-lib';

import { StudyInstance } from '../../objects/study-instance';
import { SeriesInstance } from '../../objects/series-instance';
import { InstanceService } from '../../services/instance.service';


import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';

import { DicomService } from '../../services/dicom.service';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { of } from 'rxjs';
import { SeriesComponent } from '../series/series.component';
import { CMoveRequest } from '../../objects/cmove-request';
import { MatSnackBar } from '@angular/material';

//This is a dependency of the Proton Xpress App Module
@Component({
  selector: 'study',
  templateUrl: './study.component.html',
  styleUrls: ['./study.component.scss'],
  animations: [
    trigger('rowOptions', [
      state('inactive', style({
        opacity: .5
      })),
      state('active', style({
        opacity: 1
      })),
      transition('inactive => active', animate('100ms ease-in')),
      transition('active => inactive', animate('100ms ease-out'))
    ])
  ]
})
export class StudyComponent implements OnInit, AfterViewInit {

  @Input() isFirst: Boolean;
  @Input() isLast: Boolean;
  @Input() study: StudyInstance;
  series: Array<SeriesInstance> = new Array<SeriesInstance>();
  expanded: Boolean = false;
  deleting: Boolean = false;
  hideFileNumbers: Boolean = false;
  errorText: string = null;

  pushCancelationRequested: Boolean = false;

  rowHover: string;
  showEdit: Boolean = false;

  detail: Boolean = false;
  detail$: any;

  @Input() patientContainer: any;

  pushProgress: any = {};

  popoverText: string = "";
  @ViewChild('t', { static: false }) public tooltip: NgbTooltip;
  @ViewChild('stateTip', { static: false }) public stateTip: NgbTooltip;
  @ViewChild('finalizeContent', { static: false }) public finalizeContent: any;
  @ViewChild('markContent', { static: false }) public markContent: any;

  @ViewChild('rowElement', { static: false }) rowElement: ElementRef;

  @ViewChildren(SeriesComponent) viewSeries: QueryList<SeriesComponent> = new QueryList<SeriesComponent>();

  series$: any;

  constructor(
    public is: InstanceService,
    public ces: ClientEventService,
    public ds: DicomService,
    public ses: ServerEventService,
    public modalService: NgbModal,
    public api: ApiService,
    public ms: MessageService,
    public snackBar: MatSnackBar
  ) { }

  ngOnInit() {

    this.is.clearStudyDetails$.subscribe(event => {
      this.detail = false;
      this.detail$ = of(this.detail);
    });

    this.is.cmoveStudyDetail$.subscribe(event => {
      if (event && event.record_id == this.study.record_id) {
        this.detail = true;
        this.detail$ = of(this.detail);
      }
    });

    // this.ces.expandAllPushQueue.subscribe(() => this.getThumbnails());

    this.rowHover = 'inactive';

  }

  ngAfterViewInit() {
    // this.getThumbnails();
  }

  cancelPush() {

    let request = this.ds.cMoveRequests.find((req) => req.wado_study_record_id == this.study.record_id);

    this.study.canceling = true;
    this.study.canceling$ = of(this.study.canceling);

    this.api.delete('cmove/requests/owner/' + request.request_id + '/cancel/')
      .then((res) => {

        this.study.transferring = false;
        this.study.transferring$ = of(this.study.transferring);

        // this.study.canceled = true;
        // this.study.canceled$ = of(this.study.canceled);

        this.pushCancelationRequested = true;

        this.study.pushAttempted = false;
        this.study.pushAttempted$ = of(this.study.pushAttempted);

        this.study.canceling = false;
        this.study.canceling$ = of(this.study.canceling);

        this.ces.cancelStudyPush.emit();

      })
      .catch((err) => {
        this.pushCancelationRequested = true;
        this.snackBar.open("Failed Cancelation Likely: Standby", null, {
          duration: 1000,
        });

        // this.is.getCMoveRequestAsOwner(request.request_id).then((res) => {
        //   this.study.updateProgress(new CMoveRequest(res));
        //   this.study.canceling = false;
        //   this.study.canceling$ = of(this.study.canceling);
        // });
        // this.ms.handleServerError(err);
      });
  }

  edit() {
    this.is.clearEditing();
    this.study.editing = true;
    this.is.editStudy(this.study);
  }

  closeEdit() {
    this.is.clearEditing();
    this.is.closeEdit();
  }

  delete(): any {
    this.deleting = true;
    this.study.editing = false;
    this.is.deleteStudyAsOwner(this.study)
      .then((res) => {
        if (this.is.studyEditing && this.is.studyEditing.record_id == this.study.record_id) {
          this.is.clearEditing();
          this.is.closeEdit();
        }
        this.deleting = false;
        this.ces.pushQueueDeletion.emit(this.study);
      }).catch((err) => {
        this.errorText = err;
      });
  }

  closePopover() {
    this.popoverText = '';
    this.tooltip.close();
  }

  closeStatePopover() {
    this.hideFileNumbers = false;
    this.stateTip.close();
  }

  finalizePush() {
    let totalStudies = this.is.masterStudies.length;
    let markedStudies = this.is.masterStudies.filter((st) => st.kept == true).length;
    if (totalStudies == markedStudies) {
      this.ds.cancelationRequested = false;
      this.is.clearSOPDetails$.emit();
      this.is.clearStudyDetails$.emit();
      let modalRef = this.modalService.open(this.finalizeContent, {
        backdrop: 'static',
        centered: true
      });
      this.ds.deleteAllCMoveRequests().then((res) => {
        this.ds.cMoveRequests = new Array<CMoveRequest>();

        this.is.patients.forEach((p) => {
          p.resetAllButThumbnail();
          p.studies.forEach((s) => {
            s.resetAllButThumbnail();
            s.series.forEach((se) => {
              se.resetAllButThumbnail();
              se.sops.forEach((so) => {
                so.resetAllButThumbnail();
              });
            });
          });
        });
        this.is.patients$ = of(this.is.patients);

        this.is.masterPatients.forEach((p) => {
          p.resetAllButThumbnail();
        });
        this.is.masterPatients$ = of(this.is.masterPatients);

        this.is.masterStudies.forEach((s) => {
          s.resetAllButThumbnail();
        });
        this.is.masterStudies$ = of(this.is.masterStudies);

        this.is.masterSeries.forEach((s) => {
          s.resetAllButThumbnail();
        });
        this.is.masterSeries$ = of(this.is.masterSeries);

        this.is.masterSOPs.forEach((s) => {
          s.resetAllButThumbnail();
        });
        this.is.masterSOPs$ = of(this.is.masterSOPs);

        this.is.sortMasters();
        this.ds.updatePushFlags();
        modalRef.close();
      }).catch((err) => {
        modalRef.close();
      });
    }
  }

  keepFailed() {
    this.study.kept = true;
    let mStudy = this.is.masterStudies.find((st) => st.record_id == this.study.record_id);
    mStudy.kept = true;
    let req = this.ds.cMoveRequests.find((req) => req.wado_study_record_id == this.study.record_id);

    // let serPromises = [];
    let sopPromises = [];

    // this.study.series.forEach(ser => {
    //   if (ser.pushProgress.state == 'SUCCESS') {
    //     serPromises.push(this.is.deleteSeriesAsOwner(ser));
    //   }
    // });

    // let unsuccessfulSeries = this.study.series.filter((ser) => ser.pushProgress.state != 'SUCCESS');

    let sopsForStudy = this.study.series.reduce((accumulator, currentValue) => {
      return [...accumulator, ...currentValue.sops];
    }, []);

    let successfulSops = sopsForStudy.filter((sop) => {
      return sop.pushProgress.state == 'SUCCESS';
    });

    if (this.study.series.length > 0) {


      let modalRef = this.modalService.open(this.markContent, {
        backdrop: 'static',
        centered: true
      });

      successfulSops.forEach((sop) => {
        // let sopInst = this.is.masterSOPs.find((s) => s.record_id == sop.wado_sop_record_id);
        sopPromises.push(this.is.deleteSOPAsOwner(sop));
      });

      modalRef.close();
      // Promise.all(serPromises).then((res) => {
      if (sopPromises.length > 0) {
        Promise.all(sopPromises).then((res) => {
          this.finalizePush();
        }).catch(err => console.log(err));
        // }).catch(err => console.log(err));
      }
    }

  }

  keepStudy() {
    this.study.kept = true;
    let mStudy = this.is.masterStudies.find((st) => st.record_id == this.study.record_id);
    mStudy.kept = true;
    this.finalizePush();
  }

  discardStudy() {
    this.deleting = true;
    this.is.deleteStudyAsOwner(this.study).then((res) => {
      // this.ds.cMoveRequests.splice(this.ds.cMoveRequests.findIndex((req) => req.wado_study_record_id == this.study.record_id, 1))
      // this.ds.cMoveRequests$ = of(this.ds.cMoveRequests);
      // this.ds.aggregateSOPs();
      this.deleting = false;
      this.finalizePush();
    }).catch((err) => {
      this.deleting = false;
    });
  }

  expandPopover() {
    (this.study.expanded == false) ? this.popoverText = 'Show Series' : this.popoverText = 'Hide Series';
    this.tooltip.open(this.popoverText);
  }

  expandStatePopover() {
    this.hideFileNumbers = true;
    this.stateTip.open(this.study.pushProgress.state);
  }

  toggleStudy() {
    this.study.expanded = !this.study.expanded;
    this.study.expanded$ = of(this.study.expanded);
    this.expandPopover();
  }

  getThumbnails() {
    this.study.series.forEach((se) => {
      if (se.thumbnail) {
        return;
      }
      se.loadingThumbnail = true;
      this.is.retrieveSeriesThumbnail(se.record_id, this.patientContainer.nativeElement.offsetHeight)
        .then((res) => {
          se.thumbnail = res;
          se.thumbnail$ = of(se.thumbnail);
          se.loadingThumbnail = false;
        }).catch((err) => {
          se.loadingThumbnail = false;
        });
    });
  }

  setThumbnailDimensions(thumbnail) {
    let imageHeight = 0;
    let imageWidth = 0;
    if (!this.rowElement) {
      return;
    }
    imageHeight = this.rowElement.nativeElement.offsetHeight;
    let ratioDividend = thumbnail.height / imageHeight;
    imageWidth = thumbnail.width / ratioDividend;

    thumbnail.height = imageHeight;
    thumbnail.width = imageWidth;
  }

  viewDetail() {

    this.is.clearSOPDetails$.emit();
    this.is.clearStudyDetails$.emit();

    this.is.cmoveSOPDetail = null;
    this.is.cmoveSOPDetail$.emit(this.is.cmoveSOPDetail);

    this.detail = true;

    this.is.cmoveStudyDetail = this.study;
    this.is.cmoveStudyDetail$.emit(this.is.cmoveStudyDetail);
  }

  expandChildren() {

    if (this.study.expanded == true) {
      return;
    }

    this.study.expanded = true;
    this.study.series.forEach((se) => {
      se.expanded = true;
    });
  }

  toggleRowHover(hoverState) {
    this.rowHover = hoverState;
  }

}
